import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { FeedbackList } from '../FeedbackList';
import styles from './PlanLoaderProgressV3.css';

const STEPS = ['Reading your answers', 'Matching your life chapters', 'Building your profile'];

function PlanLoaderProgressV3({ finish }) {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (progress === 100) {
            finish();

            return;
        }

        const timer = setTimeout(() => setProgress(prev => prev + 1), 100);

        return () => clearTimeout(timer);
    }, [progress]);

    const stepSize = 100 / STEPS.length;
    const currentStepIndex = Math.min(STEPS.length - 1, Math.floor(progress / stepSize));
    const visibleSteps = STEPS.slice(0, currentStepIndex + 1);

    const getStepPercent = index => {
        const min = index * stepSize;
        const max = (index + 1) * stepSize;

        if (progress <= min) return 0;
        if (progress >= max) return 100;

        return Math.round((progress - min) / (max - min) * 100);
    };

    return (
        <div className={styles.root}>
            <h1 className={styles.heading}>Building your Life Richness Profile</h1>
            <div className={styles.steps}>
                {visibleSteps.map((step, index) => {
                    const isCompleted = index < currentStepIndex;

                    return (
                        <div className={styles.step} key={step}>
                            <div className={styles.stepRow}>
                                <span>{step}</span>
                                {isCompleted ? (
                                    <span className={styles.checkmark}>
                                        <Icon name='checked' />
                                    </span>
                                ) : (
                                    <span>{getStepPercent(index)}%</span>
                                )}
                            </div>
                            {!isCompleted && (
                                <div className={styles.progressBarTrack}>
                                    <div className={styles.progressBarFill} style={{ width: `${getStepPercent(index)}%` }} />
                                </div>
                            )}
                            {index < visibleSteps.length - 1 && <div className={styles.divider} />}
                        </div>
                    );
                })}
            </div>
            <div className={styles.reviews}>
                <FeedbackList />
            </div>
        </div>
    );
}

PlanLoaderProgressV3.propTypes = {
    finish: PropTypes.func.isRequired
};

export {
    PlanLoaderProgressV3
};
